/** @format */

import React, { useEffect, useLayoutEffect } from "react";
import Lottie from "lottie-react";
import animationData from "../../../../assets/animations/tqPanelLoader.json";
import QuoteFormWrapper from "../../../../shared/components/quoteFormWrapper";
import useAppStateStore from "../../../../shared/store/AppStateStore";
import { goBackToLastStep } from "../../../../shared/utils/navigationUtils";
import QuoteStep from "../../enums/QuoteStep";
import { useNavigate } from "fusion-plugin-react-router";

const TqPanelLoader = () => {
  const STATE = useAppStateStore();
  const action = STATE.actionOnTqPanel;
  const navigate = useNavigate();

  let message = "Retrieving Quotes...";
  if (action === "UpdateQuoteResults") {
    message = "Updating quotes...";
  } else if (action === "quoteSelected") {
    message = "Selecting your quote...";
  }

  // We track the step from which the user come to the loader from, if the screen is in fact the loader itself, we send them back
  useLayoutEffect(() => {
    if (
      STATE.previousStep &&
      STATE.previousStep === QuoteStep.TQ_PANEL_LOADER
    ) {
      goBackToLastStep();
    } else {
      STATE.setPreviousStep(QuoteStep.TQ_PANEL_LOADER);
    }
  }, []);

  return (
    <QuoteFormWrapper>
      <h1>{message}</h1>
      <p>
        Sit tight, we’re collecting the best insurance options for your taxi.
      </p>
      <Lottie
        animationData={animationData}
        loop={true}
        autoplay={true}
        rendererSettings={{
          preserveAspectRatio: "xMidYMid slice",
        }}
      />
    </QuoteFormWrapper>
  );
};

export default TqPanelLoader;
